import React, { useEffect, useState } from "react";

// // import Breadcrumb from '../components/Breadcrumbs/Breadcrumb';s
// import CoverOne from "../../assets/dashboardImages/images/cover/cover-01.png";
// import userSix from "../../assets/dashboardImages/images/user/user-06.png";
import { Link, Navigate, useLocation } from "react-router-dom";
// import Breadcrumb from "../../components/Dashboard/Breadcrumbs/Breadcrumb";
import useAuth from "../../hooks/useAuth";
// import CKeditorComponent from "../../components/cKeditor/CKeditor";
import { useDropzone } from "react-dropzone";
import { useForm } from "react-hook-form";
// import { data } from "autoprefixer";
import { Flip, ToastContainer, toast } from "react-toastify";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { storage } from "../../firebase";
// import axios from "axios";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const Profile = () => {
  const { authenticated, setAuthenticated } = useAuth();
  const [userImage, setUserImage] = useState();
  const location = useLocation();
  const [imageURL, setimageURL] = useState(null);
  const axiosPrivate = useAxiosPrivate();
  const [uploadingImage, setUploadingImage] = useState(false);
  const [datejoined, setDatajoined] = useState(Date);
  // Handle file selection and set the preview image
  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    // Get the selected file
    console.log(file);
    if (file) {
      const reader = new FileReader(); // FileReader to read the file
      reader.onload = () => {
        setUserImage(reader.result); // Set the result as the preview image
      };
      reader.readAsDataURL(file);
      // Read the file as a Data URL

      try {
        setUploadingImage(true);

        const storageRef = await ref(
          storage,
          `images/profilePictures/${authenticated?.user._id}/${await event
            .target.files[0].name}`
        );
        const uploadTask = uploadBytesResumable(
          storageRef,
          event.target.files[0]
        );

        uploadTask.on(
          "state_changed",
          function (snapshot) {
            const newPercent =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            // setPercent(newPercent);
            // console.log(percent + "% done");
          },

          (error) => {
            setUploadingImage(false);
            setimageURL();
            console.log(error);
            toast.error("Something went wrong!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              transition: Flip,
            });
            // setDisabled(false);
          },
          async () => {
            // Complete function
            await getDownloadURL(uploadTask.snapshot.ref).then(
              async (downloadURL) => {
                // await setUrl(downloadURL);

                console.log(downloadURL, "url image");
                setimageURL(downloadURL);
                setUploadingImage(false);
                toast.success("image uploaded successfully!", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                  transition: Flip,
                });
                // newUserImageURL = downloadURL;
              }
            );
          }
        );
      } catch (error) {
        setUploadingImage(false);
        setimageURL();
        console.log(error);
      }
    }
  };

  useEffect(() => {
    const isoDate = authenticated?.user?.createdAt.toString();
    const date = new Date(isoDate);

    const formattedDate = date.toLocaleDateString("en-GB");
    setDatajoined(formattedDate);
  }, []);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  return (
    <>
      {/* <Breadcrumb pageName="Profile" /> */}

      <div className="overflow-hidden rounded-xl my-4  bg-black bg-opacity-50 shadow-default dark:border-strokedark dark:bg-boxdark">
        {/* <div className="relative z-20 h-35 md:h-65">
          <img
            src={CoverOne}
            alt="profile cover"
            className="h-full w-full rounded-tl-sm rounded-tr-sm object-cover object-center"
          />
          <div className="absolute bottom-1 right-1 z-10 xsm:bottom-4 xsm:right-4">
            <label
              htmlFor="cover"
              className="flex cursor-pointer items-center justify-center gap-2 rounded bg-primary py-1 px-2 text-sm font-medium text-white hover:bg-opacity-90 xsm:px-4"
            >
              <input type="file" name="cover" id="cover" className="sr-only" />
              <span>
                <svg
                  className="fill-current"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.76464 1.42638C4.87283 1.2641 5.05496 1.16663 5.25 1.16663H8.75C8.94504 1.16663 9.12717 1.2641 9.23536 1.42638L10.2289 2.91663H12.25C12.7141 2.91663 13.1592 3.101 13.4874 3.42919C13.8156 3.75738 14 4.2025 14 4.66663V11.0833C14 11.5474 13.8156 11.9925 13.4874 12.3207C13.1592 12.6489 12.7141 12.8333 12.25 12.8333H1.75C1.28587 12.8333 0.840752 12.6489 0.512563 12.3207C0.184375 11.9925 0 11.5474 0 11.0833V4.66663C0 4.2025 0.184374 3.75738 0.512563 3.42919C0.840752 3.101 1.28587 2.91663 1.75 2.91663H3.77114L4.76464 1.42638ZM5.56219 2.33329L4.5687 3.82353C4.46051 3.98582 4.27837 4.08329 4.08333 4.08329H1.75C1.59529 4.08329 1.44692 4.14475 1.33752 4.25415C1.22812 4.36354 1.16667 4.51192 1.16667 4.66663V11.0833C1.16667 11.238 1.22812 11.3864 1.33752 11.4958C1.44692 11.6052 1.59529 11.6666 1.75 11.6666H12.25C12.4047 11.6666 12.5531 11.6052 12.6625 11.4958C12.7719 11.3864 12.8333 11.238 12.8333 11.0833V4.66663C12.8333 4.51192 12.7719 4.36354 12.6625 4.25415C12.5531 4.14475 12.4047 4.08329 12.25 4.08329H9.91667C9.72163 4.08329 9.53949 3.98582 9.4313 3.82353L8.43781 2.33329H5.56219Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.99992 5.83329C6.03342 5.83329 5.24992 6.61679 5.24992 7.58329C5.24992 8.54979 6.03342 9.33329 6.99992 9.33329C7.96642 9.33329 8.74992 8.54979 8.74992 7.58329C8.74992 6.61679 7.96642 5.83329 6.99992 5.83329ZM4.08325 7.58329C4.08325 5.97246 5.38909 4.66663 6.99992 4.66663C8.61075 4.66663 9.91659 5.97246 9.91659 7.58329C9.91659 9.19412 8.61075 10.5 6.99992 10.5C5.38909 10.5 4.08325 9.19412 4.08325 7.58329Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span>Edit</span>
            </label>
          </div>
        </div> */}
        <ToastContainer />
        <div className="px-4 pb-6 text-center mt-24 flex flex-col justify-center lg:pb-8 xl:pb-11.5">
          <div className="relative flex justify-center">
            <div className="relative drop-shadow-2 rounded-2xl">
              {userImage ? (
                <img
                  src={userImage}
                  className={`rounded-full h-[150px] w-[150px] ${
                    uploadingImage == true ? "opacity-20" : " opacity-100"
                  }`}
                  alt="profile preview"
                />
              ) : (
                <img
                  src={authenticated?.user?.profilePicture}
                  className="rounded-full h-[150px] w-[150px]"
                  alt="profile"
                />
              )}

              <label
                htmlFor="profile"
                className="absolute bottom-0 right-0 flex h-8.5 w-8.5 cursor-pointer items-center justify-center rounded-full bg-primary text-white hover:bg-opacity-90 sm:bottom-2 sm:right-2"
              >
                {userImage ? (
                  <>
                    X
                    <button
                      type="file"
                      name="profile"
                      id="profile"
                      className="sr-only"
                      onClick={() => {
                        console.log("working");
                        setUserImage(null);
                      }}
                    ></button>
                  </>
                ) : (
                  <>
                    <svg
                      className="fill-current p-2 rounded-full  "
                      width="30"
                      style={{ backgroundColor: "purple", color: "white" }}
                      height="30"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.76464 1.42638C4.87283 1.2641 5.05496 1.16663 5.25 1.16663H8.75C8.94504 1.16663 9.12717 1.2641 9.23536 1.42638L10.2289 2.91663H12.25C12.7141 2.91663 13.1592 3.101 13.4874 3.42919C13.8156 3.75738 14 4.2025 14 4.66663V11.0833C14 11.5474 13.8156 11.9925 13.4874 12.3207C13.1592 12.6489 12.7141 12.8333 12.25 12.8333H1.75C1.28587 12.8333 0.840752 12.6489 0.512563 12.3207C0.184375 11.9925 0 11.5474 0 11.0833V4.66663C0 4.2025 0.184374 3.75738 0.512563 3.42919C0.840752 3.101 1.28587 2.91663 1.75 2.91663H3.77114L4.76464 1.42638ZM5.56219 2.33329L4.5687 3.82353C4.46051 3.98582 4.27837 4.08329 4.08333 4.08329H1.75C1.59529 4.08329 1.44692 4.14475 1.33752 4.25415C1.22812 4.36354 1.16667 4.51192 1.16667 4.66663V11.0833C1.16667 11.238 1.22812 11.3864 1.33752 11.4958C1.44692 11.6052 1.59529 11.6666 1.75 11.6666H12.25C12.4047 11.6666 12.5531 11.6052 12.6625 11.4958C12.7719 11.3864 12.8333 11.238 12.8333 11.0833V4.66663C12.8333 4.51192 12.7719 4.36354 12.6625 4.25415C12.5531 4.14475 12.4047 4.08329 12.25 4.08329H9.91667C9.72163 4.08329 9.53949 3.98582 9.4313 3.82353L8.43781 2.33329H5.56219Z"
                        fill=""
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.00004 5.83329C6.03354 5.83329 5.25004 6.61679 5.25004 7.58329C5.25004 8.54979 6.03354 9.33329 7.00004 9.33329C7.96654 9.33329 8.75004 8.54979 8.75004 7.58329C8.75004 6.61679 7.96654 5.83329 7.00004 5.83329ZM4.08337 7.58329C4.08337 5.97246 5.38921 4.66663 7.00004 4.66663C8.61087 4.66663 9.91671 5.97246 9.91671 7.58329C9.91671 9.19412 8.61087 10.5 7.00004 10.5C5.38921 10.5 4.08337 9.19412 4.08337 7.58329Z"
                        fill=""
                      />
                    </svg>
                    <input
                      type="file"
                      name="profile"
                      id="profile"
                      className="sr-only"
                      onChange={handleImageChange}
                    />
                  </>
                )}
              </label>
            </div>
          </div>
          <div className="mt-4">
            <h3 className="mb-1.5 text-2xl font-semibold text-white dark:text-white">
              {authenticated?.user?.name}
            </h3>
            <p className="font-medium text-white">
              {authenticated?.user?.role}
            </p>
            <div className="flex me-2 items-center justify-center">
              <h3 className="text-lg font-semibold text-white dark:text-white">
                PUBG ID :
              </h3>
              <p className="font-medium ms-2 text-white">
                {authenticated?.user?.pubgId}
              </p>
            </div>

            {/* <div className="mx-auto mt-4.5 mb-5.5 grid max-w-94 grid-cols-2 rounded-md border border-stroke py-2.5 shadow-1 dark:border-strokedark dark:bg-[#37404F]"> */}

            <div className="flex flex-col items-center justify-center gap-1 px-4 xsm:flex-row">
              <span className="font-semibold text-white dark:text-white">
                {datejoined}
              </span>
              <span className="text-sm">Joined</span>
            </div>
            {/* </div> */}

            <div>
              {location.pathname == "/dashboard/profile" ? (
                <div>
                  <form
                    className="my-4"
                    action=""
                    method="POST"
                    onSubmit={handleSubmit(async (data) => {
                      console.log(data);
                      console.log(imageURL, "yhis is image url");

                      const formData = {
                        profilePicture: imageURL,
                      };

                      console.log(formData, "this is form data");

                      await axiosPrivate
                        .put("/users/updateUser", formData, {
                          withCredentials: true,
                        })
                        .then((res) => {
                          console.log(res.data);

                          setAuthenticated((prevState) => ({
                            ...prevState, // Spread the previous state
                            user: {
                              ...prevState.user, // Spread the previous user object
                              ...formData,
                            },
                          }));
                          setUserImage(null);
                        })
                        .catch((err) => console.log(err));
                    })}
                  >
                    {/* <button className="" type="submit" value="SAVE" /> */}
                    {imageURL !== null ? (
                      <>
                        <button
                          type="submit"
                          className="inline-flex mt-4 items-center justify-center rounded-md border border-primary py-1 px-10 text-center font-medium text-primary hover:bg-opacity-90 lg:px-8 xl:px-10"
                        >
                          Save
                        </button>
                      </>
                    ) : (
                      ""
                    )}
                  </form>
                  <form
                    onSubmit={async () => {
                      await axiosPrivate("/users/deleteUser", {
                        withCredentials: true,
                      }).then((res) => {
                        if (res?.data.success == false) {
                          toast.error(
                            "User balance is greater then 0, Please apply for withdrawal first.",
                            {
                              position: "top-right",
                              autoClose: 5000,
                              hideProgressBar: false,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                              progress: undefined,
                              theme: "colored",
                              transition: Flip,
                            }
                          );
                        } else {
                          toast.success("User has been successfully deleted!", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                            transition: Flip,
                          });
                          Navigate("/login");
                        }
                      });
                    }}
                  >
                    <div>
                      <small>
                        NOTE : Your credentials will be vanished forever,
                        However your achievements and data will still be in the
                        system, A fresh user will be generated with your
                        credentials if you create a new account.
                      </small>
                    </div>
                    <span>
                      <button
                        type="submit"
                        className=" tracking-wide mt-3 font-semibold bg-red-500 text-white-500 w-full py-3 px-10 rounded-lg hover:bg-red-700 hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
                      >
                        Delete Account
                      </button>
                    </span>
                  </form>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
